import { LuminateRuntimeException } from './LuminateRuntimeException';
export class PaymentException extends LuminateRuntimeException {
    constructor(message, cause, stack) {
        super(message, cause, stack, 'PaymentException');
    }
}
